"use client"

const TailwindIndicator = () => {
  const isProd = process.env.NODE_ENV === "production"

  if (isProd) {
    return null
  }

  return (
    <div className="text-black fixed bottom-1 left-1 z-50 flex h-6 w-6 items-center justify-center rounded-full bg-[#ccc] p-3 text-xs">
      <div className="block sm_hidden">xs</div>
      <div className="hidden sm_block lg_hidden lg_hidden xl_hidden 2xl_hidden">
        sm
      </div>
      <div className="hidden lg_block lg_hidden xl_hidden 2xl_hidden">md</div>
      <div className="hidden lg_block xl_hidden 2xl_hidden">lg</div>
      <div className="hidden xl_block 2xl_hidden">xl</div>
      <div className="hidden 2xl_block">2xl</div>
    </div>
  )
}

export default TailwindIndicator
